import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5ac9342"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ws_drawer_footer" }

import { ref, computed, watch } from 'vue'
import MapCommon from '@/components/map-device'
import { lngReg, latReg, CODE_ENUM } from '@/common'
import { cloneDeep, isEmpty } from 'lodash'
import { queryLocationRgeo } from '@/api'
import { validateDMS, DMSToDecimal, decimalToDMS } from '@/utils/map.utils'

// DMS

export default /*#__PURE__*/_defineComponent({
  __name: 'map-modal',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-map-change'],
  setup(__props, { emit: __emit }) {

const latLngType = ref('DD')

const props = __props
const $emit = __emit

const mapRef = ref()
const formRef = ref()

const formData = ref({
  address: '',
  lng: '',
  lat: '',
})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      if (!isEmpty(props.data)) {
        const mo = cloneDeep(props.data)
        formData.value = mo
      }
    }
  }
)

const previewDisabled = computed(() => {
  let lng: any = formData.value.lng
  let lat: any = formData.value.lat
  if (latLngType.value === 'DMS') {
    if (!validateDMS(lng) || !validateDMS(lat)) {
      return true
    }
    lng = DMSToDecimal(formData.value.lng)
    lat = DMSToDecimal(formData.value.lat)
  }
  return !(lngReg.test(lng) && latReg.test(lat))
})

const validateMethod: any = (reg: RegExp, message: string) => {
  return (rule: any, value: any, callback: any) => {
    if (latLngType.value === 'DMS') {
      if (!validateDMS(value)) {
        callback(new Error(message))
      } else {
        const num: any = DMSToDecimal(value)
        if (reg.test(num)) {
          callback()
        } else {
          callback(new Error(message))
        }
      }
    }
    if (reg.test(value)) {
      callback()
    } else {
      callback(new Error(message))
    }
  }
}
const rules: any = {
  address: { required: true, message: '请输入' },
  lng: [
    {
      validator: validateMethod(lngReg, '格式不匹配'),
      trigger: 'blur',
    },
  ],
  lat: [
    {
      validator: validateMethod(latReg, '格式不匹配'),
      trigger: 'blur',
    },
  ],
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      const { lng, lat, address } = formData.value
      let longitude: any = lng
      let latitude: any = lat

      if (latLngType.value === 'DMS') {
        longitude = DMSToDecimal(lng)
        latitude = DMSToDecimal(lat)
      }
      console.log({ lat: latitude, lng: longitude, address })
      $emit('on-map-change', { lat: latitude, lng: longitude, address })
      $emit('update:visible', false)
      handleClose()
    }
  })
}

const handleClose = () => {
  $emit('update:visible', false)
  latLngType.value = 'DD'
}

// 预览 并且 获取定位
const toPreviewLocation = () => {
  preview()
  const { lng, lat } = formData.value
  let longitude: any = lng
  let latitude: any = lat

  if (latLngType.value === 'DMS') {
    longitude = DMSToDecimal(lng)
    latitude = DMSToDecimal(lat)
  }
  queryLocation({
    longitude,
    latitude,
  })
}

const preview = () => {
  const { lng, lat } = formData.value
  if (!lng || !lat) {
    return
  }
  let longitude: any = lng
  let latitude: any = lat
  if (latLngType.value === 'DMS') {
    longitude = DMSToDecimal(lng)
    latitude = DMSToDecimal(lat)
  }
  mapRef.value.moveMarker({
    lat: latitude,
    lng: longitude,
  })
}

const onLocationChange = ({ lng, lat }: any) => {
  let longitude = lng
  let latitude = lat

  if (latLngType.value === 'DMS') {
    longitude = decimalToDMS(lng)
    latitude = decimalToDMS(lat)
  }
  formData.value = {
    ...formData.value,
    lng: longitude,
    lat: latitude,
  }
  queryLocation({
    longitude: lng,
    latitude: lat,
  })
  formRef.value?.resetFields?.('lng')
  formRef.value?.resetFields?.('lat')
}

// 逆地理编码
const queryLocation = async ({ longitude, latitude }: any) => {
  const res: any = await queryLocationRgeo({
    longitude,
    latitude,
  })

  if (res?.code === CODE_ENUM.SUCCESS) {
    formData.value.address = res?.data?.address || ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: "地图",
    size: "800",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [
            _createTextVNode(" 取消 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(MapCommon), {
        ref_key: "mapRef",
        ref: mapRef,
        class: "map-container",
        onOnload: preview,
        onOnLocationChange: onLocationChange
      }, null, 512),
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: rules,
        class: "ws_mt32 form",
        "label-width": 80,
        "hide-required-asterisk": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "详细地址",
            prop: "address"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.address,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.address) = $event)),
                clearable: "",
                maxlength: "50"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "经      度",
                    prop: "lng"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.lng,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.lng) = $event)),
                        clearable: "",
                        maxlength: "16"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: latLngType.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((latLngType).value = $event)),
                            style: {"width":"85px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "度分秒",
                                value: "DMS"
                              }),
                              _createVNode(_component_el_option, {
                                label: "小数",
                                value: "DD"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "纬      度",
                    prop: "lat"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.lat,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.lat) = $event)),
                        clearable: "",
                        maxlength: "16"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: latLngType.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((latLngType).value = $event)),
                            style: {"width":"85px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "度分秒",
                                value: "DMS"
                              }),
                              _createVNode(_component_el_option, {
                                label: "小数",
                                value: "DD"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    disabled: previewDisabled.value,
                    onClick: toPreviewLocation
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("预览")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})